import { Link } from 'react-router-dom';
import { useTranslation } from '../../../../../utils/useTranslation';
import { SmartDrawer } from '../../../../feedback/SmartDrawer';
import { Button } from '../../../../input/Button';
import { DataTestId } from '../../../../layout/DataTestIdWrapper';
import { Flex } from '../../../../layout/Flex';
import { Typography } from '../../../../typography/Typography';
import { StatisticInfoDrawerProps } from './types';

export const StatisticInfoDrawer = ({
    title,
    content,
    moreUrl,
    statisticUrl,
    hasCloseButton,
    onClose,
    onAllStatisticClick,
}: StatisticInfoDrawerProps) => {
    const t = useTranslation();

    return (
        <SmartDrawer
            onClose={onClose}
            dataTestId={DataTestId.BUSINESS_STATISTIC_INFO_DIALOG}
            titleContent={
                <Typography variant="title3" weight="bold" mr={2}>
                    {title}
                </Typography>
            }
            mainContent={(closeHandler) => (
                <>
                    {content}
                    {hasCloseButton ? (
                        <Button
                            size="l"
                            color="secondary"
                            width="100%"
                            onClick={closeHandler}
                            mt={4}
                        >
                            {t('Понятно')}
                        </Button>
                    ) : null}
                    {moreUrl || statisticUrl ? (
                        <Flex spacing={1} mt={4} width="100%">
                            {moreUrl ? (
                                <Button
                                    as={Link}
                                    target="_blank"
                                    size="l"
                                    color="secondary"
                                    width="100%"
                                    to={moreUrl}
                                    onClick={closeHandler}
                                >
                                    {t('Подробнее')}
                                </Button>
                            ) : null}
                            {statisticUrl ? (
                                <Button
                                    as={Link}
                                    size="l"
                                    color="primary"
                                    width="100%"
                                    to={statisticUrl}
                                    onClick={onAllStatisticClick}
                                >
                                    {t('Вся статистика')}
                                </Button>
                            ) : null}
                        </Flex>
                    ) : null}
                </>
            )}
        />
    );
};
